/**
 * Obtiene el nombre de fichero a partir de una URL (sin querystring).
 *
 * @param {string} fileUrl
 * @returns {string}
 */
export function getFilenameFromUrl(fileUrl) {
    if (!fileUrl || typeof fileUrl !== 'string') {
        return ''
    }

    try {
        const path = fileUrl.split('?')[0]
        const segments = path.split('/')
        const lastSegment = segments[segments.length - 1] || ''
        return decodeURIComponent(lastSegment)
    } catch (error) {
        return ''
    }
}

/**
 * Dispara la descarga de un Blob en el navegador / WebView.
 *
 * @param {Blob} blob
 * @param {string} filename
 */
export function triggerBlobDownload(blob, filename) {
    const objectUrl = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = objectUrl
    link.setAttribute('download', filename || 'documento.pdf')
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    window.setTimeout(function () {
        window.URL.revokeObjectURL(objectUrl)
    }, 1000)
}
